import React from 'react';

import { BlockMenu } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack } from '@lyearn/ui';

import MtfOptionsListItem from './components/MtfOptionsListItem';
import { MtfEditorOptionsListItemProps } from './types';

const MtfEditorOptionsListItem: React.FC<MtfEditorOptionsListItemProps> = (props) => {
  const { className, disableReordering, getDragHandleProps } = props;

  return (
    <Stack className={cn('group mb-10', className)} gapX={8}>
      <BlockMenu
        className={cn('my-14 h-16 w-16 flex-shrink-0 opacity-0', {
          'group-hover:opacity-100': !disableReordering,
        })}
        fillColorToken="icon-placeholder"
        {...getDragHandleProps()}
      />
      <MtfOptionsListItem {...props} />
    </Stack>
  );
};

export default MtfEditorOptionsListItem;
